import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/core";
import TagValueParams from "./TagValueParams";
import SetFilterParams from "./SetFilterParams";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ScriptType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles(() => ({
    paramWrapper: {
        width: '100%',
        padding: '10px',
    },
}));

const paramTypes = {
    0: 'tagValue',
    1: 'script'
};

const ActionParams = (props) => {
    const {action, actionIndex, actions, setValue, path, createParam, removeParam, isDisabledParams} = props;
    const [tabValue, setTabValue] = useState(0);
    const classes = useStyles();
    const {type, param} = action;
    const onKeyDown = (e, paramIndex) => {
        if (e.ctrlKey && e.shiftKey && e.key === 'Insert') {
            createParam(actionIndex, paramIndex);
            return
        }

        if (e.ctrlKey && e.key === 'Insert') {
            createParam(actionIndex, paramIndex + 1);
            return
        }

        if (e.ctrlKey && e.key === 'Delete') {
            removeParam(actionIndex, paramIndex)
        }
    };

    useEffect(() => {
        if (action.paramType) {
            setTabValue(action.paramType === 'tagValue' ? 0 : 1)
        }
    }, [action.paramType]);

    function onChangeTabs(e, v) {
        setValue(
            paramTypes[v],
            `${path}.paramType`
        )
    }

    return (
        <>
            <TabsComponent
                setTabValue={onChangeTabs}
                tabValue={tabValue}
            />
            {tabValue === 0 && (
                <div className={classes.paramWrapper}>
                    {type === 'setFilter' ? (
                        <SetFilterParams
                            param={param}
                            setValue={setValue}
                            action={action}
                            path={path}
                            createParam={createParam}
                            removeParam={removeParam}
                            actionIndex={actionIndex}
                            onKeyDown={onKeyDown}
                        />
                    ) : (
                        <TagValueParams actions={actions}
                                        param={param}
                                        setValue={setValue}
                                        path={path}
                                        disabled={isDisabledParams}
                                        onKeyDown={onKeyDown}
                                        createParam={createParam}
                                        removeParam={removeParam}
                                        actionIndex={actionIndex}
                        />
                    )}
                </div>
            )}
            {tabValue === 1 && (
                <ReturnJsExecuteEditor path={path} setValue={setValue} actions={actions}/>
            )}
        </>

    )
};
export default ActionParams;

ActionParams.propTypes = {
    action: PropTypes.object,
    actionIndex: PropTypes.number,
    actions: PropTypes.array,
    setValue: PropTypes.func,
    path: PropTypes.string,
    createParam: PropTypes.func,
    removeParam: PropTypes.func
};

const TabsComponent = ({tabValue, setTabValue}) => {
    return (
        <Paper square>
            <Tabs
                value={tabValue}
                onChange={setTabValue}
                indicatorColor={'primary'}
                style={{minHeight: 30}}
            >
                <Tab value={0} label={'Tags'} style={{minHeight: 30}}/>
                <Tab value={1} label={'Script'} style={{minHeight: 30}}/>
            </Tabs>
        </Paper>
    )
};

const ReturnJsExecuteEditor = ({actions, path, setValue}) => {
    return (
        <div style={{padding: 8}}>
            <ScriptType
                labelStyles={{width: 0}}
                fieldStyles={{height: 43, width: '100%', fullWidth: true}}
                values={actions}
                field={{
                    inputMode: 'inline',
                    path: `${path}.script`,
                    syntaxHighlight: "javascript"
                }}
                setValue={setValue}
            />
        </div>
    )
};